import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Iconify from "../iconify/Iconify";

const features = [
  {
    icon: "mdi:cash-register",
    title: "Faster Billing",
    description:
      "Smooth, quick billing flow designed to reduce customer wait time.",
  },
  {
    icon: "mdi:warehouse",
    title: "Smart Inventory Control",
    description: "Real-time stock tracking with automatic low-stock alerts.",
  },
  {
    icon: "mdi:storefront-outline",
    title: "Multi-Store Management",
    description:
      "Control menus, users, and reports for all stores in one place.",
  },
  {
    icon: "mdi:cloud-lock-outline",
    title: "Secure Cloud Sync",
    description: "Your data auto-syncs securely across all devices.",
  },
];

export default function FeaturesSection() {
  return (
    <Box sx={{ width: "100%", py: 8 }}>
      <Grid
        container
        spacing={4}
        sx={{
          mx: "auto",
          justifyContent: "center",
          maxWidth: 1100,
        }}
      >
        {features.map((item, index) => (
          <Grid item key={index} size={{ xs: 12, md: 3, sm: 3 }}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                textAlign: "left",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 50,
                  height: 50,
                  borderRadius: 32,
                  backgroundColor: "#fff0f5",
                }}
              >
                <Iconify
                  icon={item.icon}
                  width={32}
                  height={32}
                  style={{ color: "#f6521a" }}
                />
              </Box>

              <Typography variant="h6" fontWeight={600} sx={{ mt: 1, mb: 1 }}>
                {item.title}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.6 }}
              >
                {item.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
